import {Component, Input, OnChanges, OnInit} from '@angular/core';

@Component({
  selector: 'vss-ui-avatar-text',
  templateUrl: './avatar-text.component.html',
  styleUrls: ['./avatar-text.component.scss']
})
export class AvatarTextComponent implements OnInit, OnChanges {
  @Input() textAvatar = ''
  @Input() numberOfChar = 3
  @Input() splitChar = ' '
  /****
   * đơn vị: px
   ***/
  @Input() sizeAvatar = 50
  charAvatar = 'AB'
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if(this.textAvatar) {
      const arr = this.textAvatar?.toUpperCase()?.split(this.splitChar)
      this.charAvatar = arr[0] ? arr[0][0] : ''
      if(arr.length >= 1 && this.numberOfChar > 1) {
        for (let i = 1; i < (arr.length > this.numberOfChar ? this.numberOfChar : arr?.length); i ++) {
          this.charAvatar += arr[i] ? arr[i][0] : ''
        }
      }
      if (!this.charAvatar) this.charAvatar = 'A'
    }
  }

}
